import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles(() => ({
  ul: {
    listStyleType: 'none',
    paddingLeft: 0,
    marginBottom: 0,
    marginTop: 0,
  },
  annotationSection: {
    border: '1px solid #e0e0e0',
    borderRadius: 4,
    padding: '12px 16px',
    marginBottom: 16,
  },
  sectionTitle: {
    display: 'inline-block',
    marginBottom: '0.3125rem',
    marginTop: 0,
    textTransform: 'uppercase',
    fontSize: '0.8125rem',
    fontWeight: 'bold',
  },
}))

export default useStyles
